<template>
  <div id="findPass">
    <el-dialog title="找回密码" :visible.sync="isFindPassShow" width="600px">
      <el-form class="findPassForm" :model="user" :rules="rules" ref="findPassRuleForm">
        <el-form-item prop="username">
          <el-input v-model="user.username" placeholder="请输入手机号" class="eb-input">
            <span slot="prepend">手机号</span>
          </el-input>
          <ebSendCode :disabled="!sendCodeParams.phoneNumber" class="eb-button-big" butId="findPassCode" :params="sendCodeParams" />
        </el-form-item>
        <el-form-item prop="phoneCode">
          <el-input v-model="user.phoneCode" placeholder="请输入验证码" class="eb-input">
            <span slot="prepend">验证码</span>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="user.password" placeholder="请输入密码" class="eb-input">
            <span slot="prepend">新密码</span>
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input type="password" v-model="user.confirmPassword" placeholder="请再次输入密码" class="eb-input">
            <span slot="prepend">确认密码</span>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="eb-button-orange eb-button-big" @click="submitForm('findPassRuleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import EventBus from '@/plugins/event-bus';
import { mobilePhoneZH, verificationcode } from '@/plugins/validator';
import { editUserPwd } from '@/services/user/user-service';
import ebSendCode from '@/components/common/eb-send-code';
export default {
  name: 'findPass',
  components: {
    ebSendCode
  },
  data() {
    return {
      isFindPassShow: false,
      user: {
        username: '',
        phoneCode: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        username: [{ validator: this.checkUserName, trigger: 'blur' }],
        phoneCode: [{ validator: this.checkPhoneCode, trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '请输入八位以上密码', trigger: 'blur' }
        ],
        confirmPassword: [{ validator: this.confirmPassword, trigger: 'blur' }]
      },
      sendCodeParams: {
        phoneNumber: '',
        verificationCodeType: 'verification_code'
      }
    };
  },
  created() {
    EventBus.$on('isFindPassShow', data => {
      this.isFindPassShow = data;
    });
  },
  methods: {
    submitForm: function(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editUserPwdService(formName);
        }
      });
    },
    async editUserPwdService(formName) {
      let params = {
        verificationCode: this.user.phoneCode,
        userPhone: this.user.username,
        newPassword: this.user.password
      };
      try {
        let { data } = await editUserPwd(params);
        if (data.returnCode === '01') {
          this.$message.success('修改密码成功');
          this.isFindPassShow = false;
          this.$refs[formName].resetFields();
        } else if (data.returnCode === '05') {
          this.$message.error('验证码不正确');
        } else {
          this.$message.error('修改密码失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    checkUserName: function(rule, value, callback) {
      this.sendCodeParams.phoneNumber = '';
      var validate = mobilePhoneZH(value);
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      if (!validate.value) {
        return callback(new Error(validate.text));
      }
      this.sendCodeParams.phoneNumber = value;
      callback();
    },
    checkPhoneCode: function(rule, value, callback) {
      var validate = verificationcode(value);
      if (!value) {
        return callback(new Error('请输入验证码'));
      }
      if (!validate.value) {
        return callback(new Error(validate.text));
      }
      callback();
    },
    confirmPassword: function(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.user.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
  }
};
</script>
<style lang="less" scoped>
#findPass {
  .eb-input {
    width: 320px;
  }
  .findPassForm {
    padding-left: 80px;
  }
}
</style>
